import { svg } from "lit";
const icon = svg `<path d="M4.1665 33.9633V31.8693H35.8331V33.9633H4.1665ZM5.83317 29.1556V19.1663H9.5938V29.1556H5.83317ZM14.002 29.1556V10.833H17.7626V29.1556H14.002ZM22.2039 29.1556V15.833H25.9645V29.1556H22.2039ZM30.4058 29.1556V5.83301H34.1664V29.1556H30.4058Z" fill="currentColor"/>`;
export default icon;
